module.exports = __webpack_public_path__ + "static/media/blockchain2.55747570.svg";